import styled from 'styled-components';
import { darken, lighten } from 'polished';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;

export const Input = styled.input.attrs({
  type: 'checkbox',
})`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const Oferta = styled.label`
  width: 35px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  font-size: 11px;
  background-color: ${({ theme }) => lighten(0.1, theme.colors.background)};
  color: ${({ theme }) => theme.colors.textBackground};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.background)};
  }

  ${Input}:checked + && {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.textPrimary};

    &:hover {
      background-color: ${({ theme }) => darken(0.05, theme.colors.primary)};
    }
  }

  ${Input}:disabled + && {
    cursor: not-allowed;
  }
`;
